import XMLHttpRequestResponseTypeEnum from '../enums/XMLHttpRequestResponseTypeEnum';
import logger from './logger';

export const getAssetsFromUrl = async (urlListObject) => {
  const urlListKeys = Object.keys(urlListObject);

  const responseObj = urlListKeys.reduce((returnObject, urlName) => {
    if (urlListObject[urlName].url === null) {
      return { ...returnObject, [urlName]: Promise.resolve(null) };
    }

    const responseType = urlListObject[urlName].responseType;
    let url = urlListObject[urlName].url;
    const headers = {
      accept: '*/*',
    };

    returnObject[urlName] = fetch(url, {
      headers,
      responseType,
    })
      .then((response) => {
        if (urlListObject[urlName].responseType === XMLHttpRequestResponseTypeEnum.arraybuffer) {
          return response.arrayBuffer();
        } else {
          return response.json();
        }
      })
      .catch((err) => {
        logger.error(`error: ${JSON.stringify(err)}`);
      });

    return returnObject;
  }, {});

  const responses = await Promise.all(Object.keys(responseObj).map((key) => responseObj[key]))
    .then((responseList) => {
      return responseList.reduce((responseObject, response, index) => {
        responseObject[urlListKeys[index]]['response'] = response;
        return { ...responseObject };
      }, urlListObject);
    })
    .catch((err) => {
      logger.error(`error: ${JSON.stringify(err)}`);
    });

  return responses;
};
